import { render, staticRenderFns } from "./TransmissionHistory.vue?vue&type=template&id=28c066ea&"
import script from "./TransmissionHistory.vue?vue&type=script&lang=js&"
export * from "./TransmissionHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransmissionHistory.vue?vue&type=style&index=0&id=28c066ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports